// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__u7DjK","legacyBtn":"MutateMid_legacyBtn__3F7Bc"};